import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2, ArrowLeft } from "lucide-react";

export default function CatalogoTerritorial() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ estado: "", municipio: "", vendedor_id: "" });

  const load = async () => {
    const [t, u] = await Promise.all([api.get("/territorial"), api.get("/users")]);
    setRows(t.data || []); setUsers(u.data || []);
  };
  useEffect(() => { load(); }, []);

  const agregar = async () => {
    if (!form.estado || !form.municipio || !form.vendedor_id) return toast.error("Complete todos los campos");
    try { await api.post("/territorial", form); toast.success("Territorio agregado"); setForm({ estado: "", municipio: "", vendedor_id: "" }); load(); }
    catch (err) { toast.error(`Error: ${err?.response?.data?.detail || err.message}`); }
  };
  const eliminar = async (id) => {
    try { await api.delete(`/territorial/${id}`); setRows((p) => p.filter((r) => r.id !== id)); toast.success("Eliminado"); }
    catch (err) { toast.error(`Error: ${err?.response?.data?.detail || err.message}`); }
  };
  const vendedorName = (id) => users.find((u) => u.id === id)?.full_name || "-";

  return (
    <div className="max-w-4xl mx-auto space-y-6" data-testid="territorial-page">
      <Button variant="ghost" size="sm" onClick={() => navigate("/configuracion")}><ArrowLeft className="h-4 w-4 mr-2" /> Configuración</Button>
      <div><h1 className="text-3xl font-bold tracking-tight">Catálogo Territorial</h1><p className="text-muted-foreground mt-2">Asignación de zonas de venta por vendedor.</p></div>
      <Card><CardContent className="pt-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
          <div className="space-y-2"><Label>Estado</Label><Input value={form.estado} onChange={(e) => setForm({ ...form, estado: e.target.value })} data-testid="terr-estado" /></div>
          <div className="space-y-2"><Label>Municipio</Label><Input value={form.municipio} onChange={(e) => setForm({ ...form, municipio: e.target.value })} data-testid="terr-municipio" /></div>
          <div className="space-y-2"><Label>Vendedor</Label>
            <Select value={form.vendedor_id} onValueChange={(v) => setForm({ ...form, vendedor_id: v })}>
              <SelectTrigger data-testid="terr-vendedor"><SelectValue placeholder="Seleccione" /></SelectTrigger>
              <SelectContent>{users.map((u) => <SelectItem key={u.id} value={u.id}>{u.full_name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <Button onClick={agregar} data-testid="terr-add"><Plus className="h-4 w-4 mr-2" /> Agregar</Button>
        </div>
        <div className="border rounded-md">
          <Table>
            <TableHeader><TableRow><TableHead>Estado</TableHead><TableHead>Municipio</TableHead><TableHead>Vendedor</TableHead><TableHead className="w-12"></TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.length === 0 ? <TableRow><TableCell colSpan={4} className="text-center h-20 text-muted-foreground">Sin registros.</TableCell></TableRow>
                : rows.map((r) => (
                  <TableRow key={r.id}><TableCell>{r.estado}</TableCell><TableCell>{r.municipio}</TableCell><TableCell>{vendedorName(r.vendedor_id)}</TableCell>
                    <TableCell><Button variant="ghost" size="icon" className="text-destructive" onClick={() => eliminar(r.id)}><Trash2 className="h-4 w-4" /></Button></TableCell></TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </CardContent></Card>
    </div>
  );
}
